import { Outlet } from 'react-router-dom'
import { ReactNode } from 'react'

export type UseSchedulingLayoutReturn = {
  children: ReactNode
}

export function useSchedulingLayout(): UseSchedulingLayoutReturn {
  return { children: <Outlet /> }
}
